<template>
	<div>
		<ModalStockistStockLog ref="ModalStockistStockLog"></ModalStockistStockLog>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Data Stok Stockist</div>
		</div>
		<v-card class="mt-3 mb-3" outlined>
			<v-list color="deep-purple lighten-5" dark class="pa-3">
				<v-list-item dense class="px-1">
					<v-spacer></v-spacer>
					<v-btn text depressed class="primary mr-2" @click="exportData">
						<v-icon>mdi-export</v-icon>
						<div class="pl-2 text-capitalize">Export</div>
					</v-btn>
					<v-btn depressed class="primary" @click="dropfilter = !dropfilter">
						<v-icon>mdi-filter</v-icon>
						<div class="pl-2">Filter</div>
					</v-btn>
				</v-list-item>
			</v-list>
		</v-card>
		<v-slide-y-transition>
			<v-card outlined class="mb-3" v-if="dropfilter">
				<filterComponent v-if="dropfilter" @searchFilter="searchFilter" @onResetFilter="onResetFilter"></filterComponent>
			</v-card>
		</v-slide-y-transition>
		<v-card outlined >
			<v-data-table loading disable-pagination :headers="headers" :items="listStockistStock" :search="search" hide-default-footer :options.sync="option" :server-items-length="paginationStockistStock.total_data">
				<template v-slot:item.action="{ item }">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn fab dark x-small depressed color="indigo" v-bind="attrs" v-on="on" @click.stop="showDetailLog(item)">
								<v-icon dark>mdi-text-box-search</v-icon>
							</v-btn>
						</template>
						<span>Riwayat Stok</span>
					</v-tooltip>
				</template>
				<template v-slot:item.stock_balance="{ item }">
					{{ item.stock_balance | toNumber }}
				</template>
				<template v-slot:progress>
					<div>
					</div>
				</template>
				<template v-slot:loading>
					<div class="py-3" v-if="!paginationStockistStock">
						<loading-data></loading-data>
					</div>
					<div class="py-3" v-else>
						<not-found></not-found>
					</div>
				</template>
			</v-data-table>
		</v-card>
		<div class="pt-5" v-if="paginationStockistStock">
			<v-row>
				<v-col cols="11" md="11" class="py-0 d-flex justify-space-between">
					<span>Total {{paginationStockistStock.total_data | toNumber}} Data</span>
					<v-pagination v-model="page" :length="paginationStockistStock.total_page" @input="changePage" total-visible="7" circle class="d-flex justify-end"></v-pagination>
				</v-col>
				<v-col cols="1" md="1" class="py-0 pl-0">
					<v-autocomplete :items="listLimit" v-model="limit" @input="changeLimit" hide-details class="mt-0" label="Item"></v-autocomplete>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex'
import filterComponent from '@/components/Filter'
import ModalStockistStockLog from './components/ModalStockistStockLog'

export default {
	inject: ['theme'],
	components: {
		filterComponent, ModalStockistStockLog
	},
	data() {
		return {
			sortBy: 'stockist_network_id',
			sortDir: 'DESC',
			page: 1,
			limit: "10",
			listLimit: [ '5', '10', '20', '50', '100' ],
			dropfilter: false,
			search: '',
			headers: [
			{ text: 'Detail', value: 'action'},
			{ text: 'Kode Member', align: 'start', value: 'stockist_network_mid'},
			{ text: 'Kode Stockist', align: 'start', value: 'stockist_code'},
			{ text: 'Nama Stockist', value: 'stockist_name'},
			{ text: 'Nama Produk', value: 'product_name'},
			{ text: 'Stok', value: 'stock_balance'},
			],
			params:[],
			isLoading: false,
			filterData: [{
				type: 'text',
				label: 'Kode Member',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'stockist_network_mid'
				}
			}, {
				type: 'text',
				label: 'Kode Stockist',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'stockist_code'
				}
			}, {
				type: 'text',
				label: 'Nama Stockist',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'stockist_name'
				}
			}, {
				type: 'selection',
				label: 'Produk',
				itemValue: 'product_code',
				itemText: 'product_name',
				item: [],
				filter: {
					value: '',
					comparison: '=',
					type: 'string',
					field: 'product_code'
				}
			}, 
			],
		}
	},
	computed: {
		...mapState(['filterParams']),
		...mapState('ecommerceStockist', ['listStockistStock', 'paginationStockistStock']),
	},
	methods: {
		...mapActions('ecommerceStockist', ['getStockistStock', 'exportStockistStock']),
		...mapActions('ecommerceCommon', ['getOptionProduct']),
		...mapMutations(['setFilter']),
		...mapMutations('ecommerceStockist', ['clearDataStockist']),

		getData() {
			this.getStockistStock(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		exportData() {
			this.exportStockistStock(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		searchFilter(data) {
			this.params = data
			this.getData()
		},
		async onResetFilter() {
			this.params = []
			this.getData()
		},
		async showDetailLog(data) {
			await this.$refs.ModalStockistStockLog.showModal(data)
		}
	},
	beforeDestroy(){
		this.clearDataStockist()
	},
	watch: {
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'ASC' : 'DESC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getData()
			}
		}
	},
	async created() {
		await this.$store.dispatch('setPageTitle', `Stok Stockist Ecommerce`)
		let indexProduct = await this.filterData.findIndex(el => el.label == 'Produk')
		this.filterData[indexProduct].item = await this.getOptionProduct()
		await this.getData()

		await this.setFilter(this.filterData)
	},
};
</script>

<style>
